<template>
  <section id="entry-index" class="layout-section -bg-shade -search-top">
    <p v-if="$wp.secondaryDataLoaded && !publicationsPage.length" class="layout-section__heading">Aucun résultat</p>

    <article v-for="publication in publicationsPage" :key="publication.id" class="card -bigger -shadow -row">
      <div class="card__info">
        <RouterLink
          :to="{ name: 'resources-monitoring-single', params: { monitoringSlug: publication.slug } }"
          class="card__title"
        >
          {{ publication.shortTitle || publication.title }}
        </RouterLink>

        <div class="card-article__uptitle">
          <div v-if="getFormattedDate(publication)" class="card-article__data">
            <SvgIcon id="content-date" />
            <p>{{ getFormattedDate(publication) }}</p>
          </div>

          <div v-if="getAuthor(publication)" class="card-article__data">
            <SvgIcon id="author" />
            <p>{{ getAuthor(publication) }}</p>
          </div>
        </div>
      </div>

      <RouterLink
        :to="{ name: 'resources-monitoring-single', params: { monitoringSlug: publication.slug } }"
        class="link card__cta"
      >
        En lire plus
        <SvgIcon id="action-arrow" />
      </RouterLink>
    </article>

    <PagePickerQuery :total-pages="totalPages" />
  </section>
</template>

<script>
import moment from 'moment'

const perPage = 18

export default {
  name: 'ResourcesMonitoringIndex',
  computed: {
    currentPage() {
      return this.$route.query.page ? Math.max(parseInt(this.$route.query.page) - 1, 0) : 0
    },
    currentType() {
      return this.$route.query.type || null
    },
    filteredPublications() {
      const allPublications = this.$wp.monitoringPublications || []
      return !this.currentType ? allPublications : allPublications.filter(pub => pub.type === this.currentType)
    },
    publicationsPage() {
      return this.filteredPublications.slice(this.currentPage * perPage, (this.currentPage + 1) * perPage)
    },
    totalPages() {
      return Math.ceil(this.filteredPublications.length / perPage)
    }
  },
  methods: {
    getFormattedDate(publication) {
      return publication && publication.original_publish_date
        ? moment(publication.original_publish_date).format('D MMMM YYYY')
        : null
    },
    getAuthor(publication) {
      if (!publication.authors || !publication.authors.length) return null
      const [authorId] = publication.authors
      const author = this.$wp.authorsById[authorId]
      return author ? author.name : null
    }
  }
}
</script>
